import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { RootReducerState } from '../../redux/Reducers';
import { rejectWithApiError } from '../../utils/api';
import { RouteParamsType } from '../../types/utils/router-params.type';
import { CellTowerCountryListResponseType, CellTowerFileType } from '../../types/cell-towers/cell-towers.type';
import { AsyncTaskType } from '../../types/async-task/async-task.type';

export const getCellTowersCountriesList = createAsyncThunk<
  CellTowerCountryListResponseType,
  RouteParamsType & { controller?: AbortController },
  { state: RootReducerState; rejectValue: string }
>('cellTowers/getCellTowersCountriesList', async (data, thunkAPI) => {
  try {
    const { controller, ...params } = data;
    const response = await axios.get<CellTowerCountryListResponseType>(`${process.env.REACT_APP_API_URL}/cell-towers`, {
      params,
      ...(controller ? { signal: controller.signal } : {}),
    });
    return response.data;
  } catch (error) {
    return rejectWithApiError({ thunkAPI, error, fallback: 'Could not fetch cell tower country files!' });
  }
});

export const postOpenCellIdFilesSync = createAsyncThunk<AsyncTaskType, void, { rejectValue: string }>(
  'cellTowers/postOpenCellIdFilesSync/no-loader',
  async (_, thunkAPI) => {
    try {
      const response = await axios.post<AsyncTaskType>(
        `${process.env.REACT_APP_API_URL}/cell-towers/opencellid-files/sync`
      );

      return response.data;
    } catch (error) {
      return rejectWithApiError({ thunkAPI, error, fallback: 'Could not start cell tower file sync!' });
    }
  }
);

export const getOpenCellIdFilesSyncTask = createAsyncThunk<AsyncTaskType, number, { rejectValue: string }>(
  'cellTowers/getOpenCellIdFilesSyncTask/no-loader',
  async (taskId, thunkAPI) => {
    try {
      const response = await axios.get<AsyncTaskType>(`${process.env.REACT_APP_API_URL}/async-task/${taskId}`);

      return response.data;
    } catch (error) {
      return rejectWithApiError({ thunkAPI, error, fallback: 'Could not fetch cell tower file sync status!' });
    }
  }
);

export const postOpenCellIdFileSync = createAsyncThunk<
  CellTowerFileType,
  { countryCode2: string; mcc: number },
  { rejectValue: string }
>('cellTowers/postOpenCellIdFileSync/no-loader', async (body, thunkAPI) => {
  try {
    const response = await axios.post<CellTowerFileType>(
      `${process.env.REACT_APP_API_URL}/cell-towers/opencellid-files`,
      body
    );

    return response.data;
  } catch (error) {
    return rejectWithApiError({ thunkAPI, error, fallback: 'Could not sync OpenCelliD file!' });
  }
});
